import type { ListingAuditReport } from '@/lib/api/listing-builder.types'
import type { AnalysisMode } from '@/components/v2/tools/amazon-listing/CampaignCreator/AnalysisModeCards'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { ReportSection } from './ReportSection'
import { MobileReportAccordion } from './MobileReportAccordion'
import { LockedAuditSection } from './LockedAuditSection'
import { SMALL_AUDIT_LOCKED_SECTIONS } from './auditConstants'
import { getVisibleSections } from './reportSectionDefs'

interface ListingReportSectionsProps {
  report: ListingAuditReport
  onUpgrade?: () => void
  analysisMode?: AnalysisMode
  mode?: 'compact' | 'full'
}

export function ListingReportSections({ report, onUpgrade, analysisMode, mode = 'full' }: ListingReportSectionsProps) {
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const isSmall = analysisMode === 'small'
  const lockedSections = isSmall && onUpgrade ? SMALL_AUDIT_LOCKED_SECTIONS : []

  const sections = getVisibleSections(report, { mode, analysisMode })

  if (!isDesktop) {
    return (
      <>
        <MobileReportAccordion sections={sections} />
        {lockedSections.map((s) => (
          <LockedAuditSection key={s.id} id={s.id} labelKey={s.labelKey} onUpgrade={onUpgrade!} />
        ))}
      </>
    )
  }

  return (
    <div className="space-y-5 max-w-4xl">
      {sections.map((s) => (
        <ReportSection key={s.id} id={s.id} content={s.content}>
          {s.node}
        </ReportSection>
      ))}
      {lockedSections.map((s) => (
        <LockedAuditSection key={s.id} id={s.id} labelKey={s.labelKey} onUpgrade={onUpgrade!} />
      ))}
    </div>
  )
}
